import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC41BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import { ArchivoOpcionalComponent } from '../../ArchivosComponents/ArchivoOpcionalComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    resetDataFC_41, actualizarFC_41Estatus, actualizarFC_41Solicitud,
    actualizarFileFC_41, agregarFileFC_41,
} from '../../../redux/DucksBeneficiario/FC_41Ducks';
import moment from 'moment'


const DocumentacionFC_41Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_41Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_41Solicitud.dataDocumentacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesFC_41 = useSelector(store => store.FC_41Solicitud.filesProductos)

    let filesMap = useSelector(store => store.FC_41Solicitud.filesProductosMap)
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {

        let countArchivos = 0
        for(const i in data.fc_41_anexoproducto){
            let cortegranel = data.fc_41_anexoproducto[i].numeroanalisisgranel.split(',')
            countArchivos += ((cortegranel.length) + 2)
        }
        const totalFilesGenerales = (files.filter(file => file.estatus === true)).length
        let contadorArchivo = 0//totalFilesGenerales

        for (const i in data.fc_41_anexoproducto) {
            let cortegranel = data.fc_41_anexoproducto[i].numeroanalisisgranel
            for(const id in cortegranel){
                let filesDPAG = files.filter(anexo => (anexo.id).includes(`DPAG${i}${id}`))
                if (filesDPAG.length > 0) contadorArchivo += 1
            }
            
            let filesDPCP = files.filter(anexo => (anexo.id).includes(`DPCN${i}`))
            let filesDPJE = files.filter(anexo => (anexo.id).includes(`DPJE${i}`))
            
            if (filesDPCP.length > 0) contadorArchivo += 1
            if (filesDPJE.length > 0) contadorArchivo += 1
        }
        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc41_solicitudparabebidasconm: data.idfc41_solicitudparabebidasconm }
            await dispatch(actualizarFC_41Solicitud({ solicitud: solicitud }))
            setFolio(data.folio)
            const idSolicitud = data.idfc41_solicitudparabebidasconm
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_41 = 12
            const tabla = tablaFC_41
            await dispatch(actualizarFC_41Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_41())
            setEnvioCorrecto(true)
        }
    }


    React.useEffect(() => {
        if (filesFC_41?.data) {
            let newFiles = []
            for (const file in filesFC_41?.data) {
                const { ...newFile } = filesFC_41?.data?.[file]
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }
    }, [data])

    //FILES GENERALES
    const [files, setFile] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_41/agregarNuevoFC_41AnexosArchivosProducto'
        }
        const result = await dispatch(agregarFileFC_41(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_35archivos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrev = async (objectFile) => {

        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_41/actualizarFormatoFC41_AnexosArchivosProducto'
                }
                const result = await dispatch(actualizarFileFC_41(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_41/agregarNuevoFC_41AnexosArchivosProducto'
                    }
                    result = await dispatch(agregarFileFC_41(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }

    const FilesGenerales = () => {
        let file = []
        let certificadoAnalisis = []
        return (
            <Collapsible trigger="Documentación de productos" className='mb-3'>
                {data?.fc_41_anexoproducto?.map((anexo, index) => (
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <label className='text-center'>Producto {Number(index) + Number(1)}: {anexo.tipobebida}</label>
                        {file = anexo.numeroanalisisgranel.split(',')}
                        {certificadoAnalisis = anexo.numeroanalisisbebida.split(',')}
                        {file.map((analisis, i) => (
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DPAG${index}${i}`} tabla={"FC_41_anexos"}
                                filesMap={filesMap} textLabel={`Análisis de laboratorio a granel del mezcal ${analisis}: `}
                                textoTooltip='En cumplimiento con el apartado 4.3 de la NOM-070-SCFI-2016.'
                                idAnexoFK={anexo?.idfc41_anexoproducto} />
                        ))}

                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DPCN${index}`} tabla={"FC_41_anexos"}
                            filesMap={filesMap} textLabel={`Certificado NOM a granel vigente del mezcal: `}
                            textoTooltip='Certificado NOM a granel vigente del mezcal.'
                            idAnexoFK={anexo?.idfc41_anexoproducto} />
                        {certificadoAnalisis.map((certificado, i) => (
                            <ArchivoOpcionalComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DPAB${index}${i}`} tabla={"FC_41_anexos"}
                                filesMap={filesMap} textLabel={`Análisis de laboratorio de % Alc. Vol. de la bebida con mezcal ${certificado}: `}
                                textoTooltip='En la bebida alcohólica con Mezcal.'
                                idAnexoFK={anexo?.idfc41_anexoproducto} />
                        ))}
                        {data.ventaexportacion && <>
                            <ArchivoOpcionalComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DPOC${index}`} tabla={"FC_41_anexos"}
                                filesMap={filesMap} textLabel={`Orden de compra del importador: `}
                                textoTooltip='O invitación a la feria o exposición en el extranjero.'
                                idAnexoFK={anexo?.idfc41_anexoproducto} />
                            <ArchivoOpcionalComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DPFP${index}`} tabla={"FC_41_anexos"}
                                filesMap={filesMap} textLabel={`Factura o proforma: `}
                                textoTooltip='En caso de que el producto se exporte con fines de promoción, entregar factura sin valor comercial.'
                                idAnexoFK={anexo?.idfc41_anexoproducto} />
                        </>}
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DPJE${index}`} tabla={"FC_41_anexos"}
                            filesMap={filesMap} textLabel={`Juego de etiquetas aprobadas por COMERCAM: `}
                            textoTooltip='Juego de etiquetas aprobadas por COMERCAM.'
                            idAnexoFK={anexo?.idfc41_anexoproducto} />


                    </div>
                ))}
            </Collapsible>
        )
    }

    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {FilesGenerales()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envío</button>
                    </div>
                }
            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_41Component)
